// Modale de sélection de source pour le partage d'écran sous Electron.
// Intercepte l'event chaos:show-screen-picker émis par main.js quand
// getDisplayMedia() est appelé, affiche les sources, et renvoie le choix.

let _pendingCallback = null;
let _selectedSourceId = null;

function _buildModal() {
    if (document.getElementById('screen-picker-overlay')) return;

    const overlay = document.createElement('div');
    overlay.id = 'screen-picker-overlay';
    overlay.className = 'modal-overlay';
    overlay.innerHTML = `
        <div class="modal-box spm-box">
            <div class="modal-header">
                <h2><i class="fas fa-desktop"></i> Partager l'écran</h2>
                <button class="close-btn" id="spm-close" aria-label="Fermer">×</button>
            </div>
            <div class="modal-body spm-body">
                <div id="spm-screens-section">
                    <div class="spm-section-title">Écrans</div>
                    <div class="spm-grid" id="spm-screens-grid"></div>
                </div>
                <div id="spm-windows-section">
                    <div class="spm-section-title">Fenêtres</div>
                    <div class="spm-grid" id="spm-windows-grid"></div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="cyber-btn btn-alt" id="spm-cancel">Annuler</button>
                <button class="cyber-btn" id="spm-share" disabled>
                    <i class="fas fa-share-square"></i> Partager
                </button>
            </div>
        </div>
    `;
    document.body.appendChild(overlay);

    document.getElementById('spm-close').addEventListener('click', _cancel);
    document.getElementById('spm-cancel').addEventListener('click', _cancel);
    document.getElementById('spm-share').addEventListener('click', _share);
    overlay.addEventListener('click', e => { if (e.target === overlay) _cancel(); });
}

function _populateSources(sources) {
    _selectedSourceId = null;
    const shareBtn = document.getElementById('spm-share');
    if (shareBtn) shareBtn.disabled = true;

    const screens = sources.filter(s => s.id.startsWith('screen:'));
    const windows = sources.filter(s => !s.id.startsWith('screen:'));

    _fillGrid(document.getElementById('spm-screens-grid'), screens);
    _fillGrid(document.getElementById('spm-windows-grid'), windows);

    const windowsSection = document.getElementById('spm-windows-section');
    if (windowsSection) windowsSection.style.display = windows.length ? '' : 'none';
}

function _fillGrid(grid, sources) {
    if (!grid) return;
    grid.innerHTML = '';

    if (!sources.length) {
        grid.innerHTML = '<div class="spm-empty">Aucune source disponible</div>';
        return;
    }

    for (const source of sources) {
        const card = document.createElement('div');
        card.className = 'spm-source-card';
        card.dataset.sourceId = source.id;

        const img = document.createElement('img');
        img.className = 'spm-thumb';
        img.src = source.thumbnail;
        img.alt = source.name;

        const name = document.createElement('div');
        name.className = 'spm-source-name';
        name.textContent = source.name;

        card.appendChild(img);
        card.appendChild(name);
        card.addEventListener('click', () => _selectCard(card, source.id));
        // Double-clic = sélectionner et partager directement
        card.addEventListener('dblclick', () => { _selectCard(card, source.id); _share(); });
        grid.appendChild(card);
    }
}

function _selectCard(card, sourceId) {
    document.querySelectorAll('#screen-picker-overlay .spm-source-card.selected')
        .forEach(c => c.classList.remove('selected'));
    card.classList.add('selected');
    _selectedSourceId = sourceId;

    const shareBtn = document.getElementById('spm-share');
    if (shareBtn) shareBtn.disabled = false;
}

function _cancel() {
    _closeModal();
    if (_pendingCallback) { _pendingCallback(null); _pendingCallback = null; }
}

function _share() {
    if (!_selectedSourceId) return;
    const sourceId = _selectedSourceId;
    _closeModal();
    if (_pendingCallback) { _pendingCallback(sourceId); _pendingCallback = null; }
}

function _closeModal() {
    const overlay = document.getElementById('screen-picker-overlay');
    if (overlay) overlay.style.display = 'none';
}

export function initScreenPicker() {
    if (!window.chaosNative?.isElectron) return;

    _buildModal();

    window.chaosNative.onShowScreenPicker(sources => {
        _populateSources(sources);

        const overlay = document.getElementById('screen-picker-overlay');
        if (overlay) overlay.style.display = 'flex';

        _pendingCallback = sourceId => window.chaosNative.chooseSource(sourceId);
    });
}
